// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ff8df7e6e087331ff134","655":"ad36e63ddc36512daec7"}[chunkId] + ".js";
};